var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePayLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56.6,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 56.6,
    rx: 2.28571,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1041 19.9837V16.2459V16.2452H25.1237C25.9564 16.2457 26.6561 15.9837 27.223 15.4593C27.796 14.9617 28.1163 14.2461 28.1 13.5002C28.1113 12.7585 27.7916 12.0483 27.223 11.5522C26.6611 11.0249 25.9053 10.7372 25.1237 10.7531H21.8817V19.9837H23.1041ZM23.1041 15.1116V11.8894V11.8886H25.1541C25.611 11.8762 26.0514 12.0545 26.3636 12.3784C26.6776 12.6746 26.8548 13.0815 26.8548 13.5064C26.8548 13.9313 26.6776 14.3382 26.3636 14.6344C26.0476 14.9514 25.6085 15.1247 25.1541 15.1116H23.1041Z",
    fill: "#5F6368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0563 14.1645C32.5334 13.6961 31.8202 13.4619 30.9167 13.4619C29.7561 13.4619 28.8797 13.8744 28.2874 14.6992L29.3641 15.3569C29.7619 14.7982 30.3022 14.5188 30.9851 14.5188C31.4204 14.5139 31.8417 14.6682 32.1649 14.9511C32.4873 15.2096 32.6727 15.595 32.6699 16.0007V16.2717C32.2001 16.0139 31.6023 15.885 30.8765 15.885C30.0261 15.886 29.3463 16.0795 28.8371 16.4654C28.3279 16.8513 28.0733 17.3711 28.0733 18.0246C28.0622 18.6197 28.3283 19.1879 28.7977 19.5712C29.2805 19.9837 29.8806 20.1899 30.5978 20.1899C31.4381 20.1899 32.1113 19.829 32.6175 19.1072H32.6706V19.9837H33.8399V16.0912C33.8404 15.2752 33.5792 14.633 33.0563 14.1645ZM29.7407 18.8237C29.4846 18.6446 29.3336 18.3565 29.3353 18.0503C29.3353 17.7064 29.5015 17.4199 29.8364 17.1842C30.1679 16.9519 30.582 16.8358 31.0785 16.8358C31.7603 16.8358 32.2918 16.9831 32.6729 17.2777C32.6729 17.7756 32.4705 18.2094 32.0655 18.5791C31.7008 18.933 31.2064 19.1322 30.6905 19.133C30.3466 19.1392 30.0111 19.03 29.7407 18.8237Z",
    fill: "#5F6368"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5517 13.6682L36.47 22.7678H35.2081L36.7228 19.5838L34.0389 13.6682H35.3676L37.3075 18.2051H37.334L39.2208 13.6682H40.5517Z",
    fill: "#5F6368"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1644 15.4401C18.1648 15.0787 18.1333 14.718 18.0702 14.3618H12.9149V16.4042H15.8676C15.7455 17.0633 15.3511 17.6454 14.7758 18.0156V19.3413H16.5381C17.5699 18.4185 18.1644 17.0538 18.1644 15.4401Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9149 20.6222C14.3901 20.6222 15.6323 20.1523 16.538 19.3421L14.7758 18.0164C14.2853 18.339 13.6536 18.5231 12.9149 18.5231C11.489 18.5231 10.2788 17.5907 9.84598 16.3342H8.03061V17.7005C8.95853 19.4916 10.8484 20.6221 12.9149 20.6222Z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84604 16.3343C9.61725 15.6759 9.61725 14.9629 9.84604 14.3045V12.9382H8.03067C7.25454 14.4364 7.25454 16.2023 8.03067 17.7005L9.84604 16.3343Z",
    fill: "#FBBC04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9149 12.1158C13.6945 12.1034 14.4478 12.3891 15.0119 12.9112V12.9112L16.5722 11.3977C15.5828 10.4962 14.2721 10.0013 12.9149 10.0167C10.8484 10.0168 8.95853 11.1473 8.03061 12.9384L9.84598 14.3047C10.2788 13.0482 11.489 12.1158 12.9149 12.1158Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayLogo);
export default __webpack_public_path__ + "static/media/google-pay-logo.32215f4da5ffb330b955999d4e8ee860.svg";
export { ForwardRef as ReactComponent };